import React, { useState } from "react";
import "./EmojiTicTacToe.css";

const defaultEmojis = ["❌","⭕","🍎","🍌","🚀","⚽","🎮","🐱","🐶","🌟"];

export default function EmojiTicTacToe() {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [isXTurn, setIsXTurn] = useState(true);
  const [winner, setWinner] = useState(null);
  const [message, setMessage] = useState("");
  const [playerX, setPlayerX] = useState("❌");
  const [playerO, setPlayerO] = useState("⭕");
  const [gameStarted, setGameStarted] = useState(false);

  // Load sounds
  const moveSound = new Audio("/sounds/correct.mp3");
  const winSound = new Audio("/sounds/win.mp3");
  const drawSound = new Audio("/sounds/wrong.wav");

  const handleClick = (index) => {
    if (!gameStarted || board[index] || winner) return;
    const newBoard = [...board];
    newBoard[index] = isXTurn ? playerX : playerO;
    setBoard(newBoard);
    setIsXTurn(!isXTurn);
    moveSound.play(); // play on every move
    checkWinner(newBoard);
  };

  const checkWinner = (board) => {
    const combos = [
      [0,1,2],[3,4,5],[6,7,8],
      [0,3,6],[1,4,7],[2,5,8],
      [0,4,8],[2,4,6]
    ];
    for (let combo of combos) {
      const [a,b,c] = combo;
      if (board[a] && board[a] === board[b] && board[a] === board[c]) {
        setWinner(board[a]);
        setMessage(`🎉 Winner: ${board[a]}`);
        winSound.play(); // play win sound
        return;
      }
    }
    if (board.every(cell => cell)) {
      setWinner("draw");
      setMessage("🤝 It's a draw!");
      drawSound.play(); // play draw sound
    } else {
      setMessage(`Next turn: ${isXTurn ? playerO : playerX}`);
    }
  };

  const resetGame = () => {
    setBoard(Array(9).fill(null));
    setIsXTurn(true);
    setWinner(null);
    setMessage("");
    setGameStarted(false);
  };

  return (
    <div className="tic-container">
      <h1>🎮 Emoji Tic Tac Toe</h1>

      {!gameStarted && (
        <div className="emoji-select">
          <p>Choose your emojis:</p>
          <div>
            <label>Player X: </label>
            <select value={playerX} onChange={(e)=>setPlayerX(e.target.value)}>
              {defaultEmojis.map((emoji,i)=><option key={i} value={emoji}>{emoji}</option>)}
            </select>
          </div>
          <div>
            <label>Player O: </label>
            <select value={playerO} onChange={(e)=>setPlayerO(e.target.value)}>
              {defaultEmojis.map((emoji,i)=><option key={i} value={emoji}>{emoji}</option>)}
            </select>
          </div>
          <button onClick={()=>setGameStarted(true)} className="start-btn">▶️ Start Game</button>
        </div>
      )}

      {gameStarted && (
        <>
          <div className="board">
            {board.map((cell, index) => (
              <div
                key={index}
                className={`cell ${cell ? "filled" : ""}`}
                onClick={() => handleClick(index)}
              >
                {cell}
              </div>
            ))}
          </div>
          <p className="status">{message}</p>
          <button onClick={resetGame} className="reset-btn">🔄 Reset</button>
        </>
      )}
    </div>
  );
}
